export function hasRolePermission(roles, capabilityKey) {
    if (!capabilityKey) return true;
    if (!Array.isArray(roles) || roles.length === 0) return false;

    return roles.some((role) => role?.permissions?.[capabilityKey] === true);
}

export function hasFacilityPermission(facility, capabilityKey) {
    try {
        return Boolean(facility?.permissions?.[capabilityKey]);
    } catch (err) {
        return false;
    }
}

export const WIDGET_PERMISSION_MAP = {
    highCost: 'canViewHighCost',
    highcostalerts: 'canViewHighCostAlerts',
    openBatch: 'canViewOpenBatch',
    nonCovered: 'canViewNonCovered',
    priorAuth: 'canViewPriorAuth',
    theraInt: 'canViewTherapeuticInterchange',
    admissionMeds: 'canViewAdmissionMeds',
    refillTooSoon: 'canViewRefillTooSoon',
    pumpPickup: 'canViewPumpPickup',
    narcoticsRefill: 'canViewNarcoticsRefill',
    alfNewScript: 'canViewAlfNewScript',
    alfCostResponse: 'canViewAlfNonActionOrDenial',
    unavailableMedicationAlerts: 'canViewSpecialtyMedOrNotAvailable',
};

export function hasWidgetViewPermission(roles, widgetName) {
    const capabilityKey = WIDGET_PERMISSION_MAP[widgetName];
    if (!capabilityKey) return true;

    return hasRolePermission(roles, capabilityKey);
}

export const PAGE_PERMISSION_MAP = {
    'discharge summary': 'canViewDischargeSummary',
    'secure forms': 'canViewSecureForms',
    'packing slips': 'canViewPackingSlips',
    'file manager': 'canViewFileManager',
    'order return': 'canViewOrderReturns',
    'order return lookup view': 'canViewOrderReturns',
    'narcotic destruction': 'canViewNarcotic',
    'drug quotes': 'canViewDrugQuote',
    'saved drug quotes': 'canViewDrugQuote',
    'pharmacy reports': 'canViewManageReports',
};

export function hasPageViewPermission(roles, pageName = '') {
    const capabilityKey = PAGE_PERMISSION_MAP[pageName.trim().toLowerCase()];
    if (!capabilityKey) return true;

    return hasRolePermission(roles, capabilityKey);
}
